import Vue from "vue";
import Vuex from "vuex";
import Auth from "./modules/Auth";
import User from "./modules/User";
import Plans from "./modules/Plans";
import Products from "./modules/Products";
import Roles from "./modules/Roles";
import Organizations from "./modules/Organizations";
import Projects from "./modules/Projects";
import Media from "./modules/Media";
import Candidates from "./modules/Candidates";
import Matches from "./modules/Matches";
import Dashboard from "./modules/Dashboard";
import Helpers from "./modules/Helpers";
import Loader from "./modules/Loader";
import UserFiles from "./modules/UserFiles";
import UserFilesCustomLuts from "./modules/UserFilesCustomLuts";
import UI from "./modules/UI";
import App from "./modules/App";
import Files from "@/store/modules/Files";
import Scopes from "@/store/modules/Scopes";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		loading: false,
	},
	modules: {
		Auth,
		User,
		Plans,
		Products,
		Roles,
		Organizations,
		Projects,
		File: {
			namespaced: true,
			modules: {
				Media,
				Candidates,
				Matches
			}
		},
		Dashboard,
		Helpers,
		Loader,
		UserFiles,
		UserFilesCustomLuts,
		UI,
		Scopes,
		App,
		Files
	},
	strict: process.env.NODE_ENV !== "production",
	actions: {
		resetAll: ({ dispatch }) => {
			dispatch("Auth/resetState");
			dispatch("Dashboard/resetState");
			dispatch("Organizations/resetState");
			dispatch("Plans/resetState");
			dispatch("Roles/resetState");
			dispatch("User/resetState");
			dispatch("UserFiles/resetState");
			dispatch("Loader/resetState");
			dispatch("UI/resetState");
			dispatch("App/resetState");
			dispatch("Scopes/resetState");
		},
		resetData: ({ dispatch }) => {
			dispatch("Dashboard/resetState");
			dispatch("Organizations/resetState");
			dispatch("Plans/resetState");
			dispatch("Roles/resetState");
			dispatch("User/resetState");
			dispatch("UserFiles/resetState");
			dispatch("Loader/resetState");
			dispatch("UI/resetState");
			dispatch("App/resetState");
			dispatch("Scopes/resetState");
		},
		resetApp: ({ dispatch }) => {
			dispatch("UserFiles/resetState");
			dispatch("Loader/resetState");
			dispatch("UI/resetState");
			dispatch("App/resetState");
			dispatch("Scopes/resetState");
		},
	}
});
